var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _rect, _polygon14, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _polygon15, _path7, _rect3, _path8, _polygon16, _polygon17, _path9, _polygon18, _polygon19, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2eb298;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#fff;}.cls-3{fill:#32b298;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "96.14 48.76 76.93 75.1 81.03 75.1 100.25 48.76 96.14 48.76"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "87.49 48.76 68.27 75.1 72.38 75.1 91.59 48.76 87.49 48.76"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "78.94 48.76 59.72 75.1 63.83 75.1 83.04 48.76 78.94 48.76"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "70.38 48.76 53.48 71.92 53.48 75.1 55.27 75.1 74.48 48.76 70.38 48.76"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.82 48.76 53.48 60.18 53.48 65.8 65.92 48.76 61.82 48.76"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "53.48 48.76 53.48 54.1 57.38 48.76 53.48 48.76"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "76.99 75.1 96.21 101.44 100.31 101.44 81.09 75.1 76.99 75.1"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.33 75.1 87.55 101.44 91.66 101.44 72.44 75.1 68.33 75.1"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "59.79 75.1 79 101.44 83.11 101.44 63.89 75.1 59.79 75.1"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.48 75.1 53.48 78.19 70.44 101.44 74.54 101.44 55.33 75.1 53.48 75.1"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.48 89.93 61.88 101.44 65.98 101.44 53.48 84.31 53.48 89.93"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.48 101.44 57.45 101.44 53.48 96.01 53.48 101.44"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.85 62.72 129.73 65.92 129.73 71.71 124.4 71.71 124.4 48.82 129.73 48.82 129.73 59.51 140.02 48.82 145.99 48.82 136.37 59.02 146.55 71.71 140.28 71.71 132.85 62.72"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 157.1,
    y: 48.81,
    width: 5.37,
    height: 22.9
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "197.43 48.82 197.43 71.71 193.02 71.71 181.44 57.81 181.44 71.71 176.13 71.71 176.13 48.82 180.58 48.82 192.12 62.72 192.12 48.82 197.43 48.82"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.78,59.91h4.91v9.29c-2.55,1.9-6.07,2.91-9.39,2.91-7.3,0-12.67-4.94-12.67-11.84s5.37-11.84,12.77-11.84c4.08,0,7.46,1.37,9.72,3.96l-3.45,3.14c-1.69-1.77-3.65-2.58-6-2.58-4.51,0-7.59,2.98-7.59,7.33s3.08,7.33,7.53,7.33c1.46,0,2.82-.26,4.18-.98v-6.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243,69.46l1.83-3.99c1.96,1.41,4.87,2.39,7.66,2.39,3.18,0,4.48-1.05,4.48-2.45,0-4.29-13.5-1.34-13.5-9.85,0-3.89,3.18-7.13,9.78-7.13,2.92,0,5.9.69,8.06,2.03l-1.66,4.02c-2.16-1.21-4.38-1.8-6.44-1.8-3.18,0-4.41,1.18-4.41,2.62,0,4.22,13.5,1.31,13.5,9.72,0,3.83-3.22,7.1-9.85,7.1-3.68,0-7.4-1.08-9.45-2.65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.03,64.91c0-1.93-1.49-2.84-4.28-2.84h-6.27v5.66h6.27c2.79,0,4.28-.85,4.28-2.81M279.48,52.81v5.4h5.34c2.62,0,4.05-.92,4.05-2.71s-1.43-2.68-4.05-2.68h-5.34ZM295.44,65.47c0,3.96-3.18,6.25-9.29,6.25h-12.01v-22.9h11.34c5.81,0,8.79,2.39,8.79,5.95,0,2.29-1.19,4.06-3.09,5.04,2.59.82,4.25,2.78,4.25,5.66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M317.43,53.13h-4.38v7.98h4.38c3.28,0,4.94-1.5,4.94-3.99s-1.66-3.99-4.94-3.99M322.47,71.71l-4.48-6.38h-4.94v6.38h-5.37v-22.9h10.05c6.2,0,10.08,3.17,10.08,8.31,0,3.43-1.76,5.95-4.78,7.23l5.21,7.36h-5.77Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 340.21,
    y: 48.81,
    width: 5.37,
    height: 22.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.53,67.36c4.61,0,7.63-2.71,7.63-7.1s-3.02-7.1-7.63-7.1h-4.91v14.2h4.91ZM359.25,48.82h10.55c7.6,0,12.8,4.52,12.8,11.45s-5.21,11.45-12.8,11.45h-10.55v-22.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M410.5,59.91h4.91v9.29c-2.55,1.9-6.07,2.91-9.39,2.91-7.3,0-12.67-4.94-12.67-11.84s5.37-11.84,12.77-11.84c4.08,0,7.46,1.37,9.72,3.96l-3.45,3.14c-1.69-1.77-3.65-2.58-6-2.58-4.51,0-7.59,2.98-7.59,7.33s3.08,7.33,7.53,7.33c1.46,0,2.82-.26,4.18-.98v-6.71Z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "446.52 67.46 446.52 71.71 428.54 71.71 428.54 48.82 446.09 48.82 446.09 53.07 433.88 53.07 433.88 58.04 444.66 58.04 444.66 62.16 433.88 62.16 433.88 67.46 446.52 67.46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.57,92.26h-2.15v3.92h2.15c1.61,0,2.43-.74,2.43-1.96s-.81-1.96-2.43-1.96M278.05,101.38l-2.2-3.13h-2.43v3.13h-2.64v-11.24h4.94c3.05,0,4.95,1.56,4.95,4.08,0,1.69-.86,2.92-2.35,3.55l2.56,3.61h-2.83Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 287.82,
    y: 90.14,
    width: 2.64,
    height: 11.24
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M305.93,95.58h2.41v4.56c-1.25.93-2.98,1.43-4.61,1.43-3.58,0-6.22-2.42-6.22-5.81s2.64-5.81,6.27-5.81c2,0,3.66.67,4.77,1.94l-1.7,1.54c-.83-.87-1.79-1.27-2.95-1.27-2.22,0-3.73,1.46-3.73,3.6s1.51,3.6,3.7,3.6c.72,0,1.38-.13,2.05-.48v-3.29Z"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "326.3 90.14 326.3 101.38 323.66 101.38 323.66 96.77 318.48 96.77 318.48 101.38 315.84 101.38 315.84 90.14 318.48 90.14 318.48 94.57 323.66 94.57 323.66 90.14 326.3 90.14"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "336.43 92.26 332.78 92.26 332.78 90.14 342.72 90.14 342.72 92.26 339.07 92.26 339.07 101.38 336.43 101.38 336.43 92.26"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.67,98.04c0-.95-.73-1.4-2.1-1.4h-3.08v2.78h3.08c1.37,0,2.1-.42,2.1-1.38M361.49,92.1v2.65h2.62c1.29,0,1.99-.45,1.99-1.33s-.7-1.32-1.99-1.32h-2.62ZM369.33,98.32c0,1.94-1.56,3.07-4.56,3.07h-5.9v-11.24h5.57c2.85,0,4.32,1.17,4.32,2.92,0,1.13-.59,1.99-1.52,2.47,1.27.4,2.09,1.37,2.09,2.78"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "381.62 97.4 381.62 101.38 378.98 101.38 378.98 97.37 374.57 90.14 377.37 90.14 380.42 95.13 383.46 90.14 386.05 90.14 381.62 97.4"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "407.37 97.4 407.37 101.38 404.73 101.38 404.73 97.37 400.32 90.14 403.12 90.14 406.16 95.13 409.21 90.14 411.8 90.14 407.37 97.4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M426.57,95.76c0-2.14-1.53-3.6-3.57-3.6s-3.57,1.46-3.57,3.6,1.53,3.6,3.57,3.6,3.57-1.46,3.57-3.6M416.76,95.76c0-3.34,2.64-5.82,6.24-5.82s6.24,2.46,6.24,5.82-2.65,5.81-6.24,5.81-6.24-2.47-6.24-5.81"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.19,96.44v-6.3h2.64v6.2c0,2.14.94,3.02,2.54,3.02s2.54-.88,2.54-3.02v-6.2h2.61v6.3c0,3.31-1.92,5.14-5.16,5.14s-5.16-1.83-5.16-5.14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbLogo);
export default __webpack_public_path__ + "static/media/KBLogo.ce5f9741ae713385a40f8774bbf2f6d2.svg";
export { ForwardRef as ReactComponent };